export default __webpack_public_path__ + "static/media/closet5-after3-1920w.bf7f896a.png";